import Footer from "../Components/Footer";
import AssetWrapper from "../Wrapper/AssetWrapper";
import HistoryWrapper from "../Wrapper/HistoryWrapper";

const RankPage =() => {

    return(
    <div className="rankpage">
        <h1>RankPage</h1>
        <HistoryWrapper/>
        <AssetWrapper/>
        <Footer/>

    </div>
    )
}
export default RankPage;